import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()
export class FormService {
  constructor() {}

  isFieldValid(field: string, formGroup: FormGroup) {
    return field && formGroup && !formGroup.get(field).valid && formGroup.get(field).touched;
  }

  displayFieldCss(field: string, formGroup: FormGroup) {
    return {
      'has-error': this.isFieldValid(field, formGroup),
      'has-feedback': this.isFieldValid(field, formGroup),
    };
  }
}
